import React from 'react';

import { CartHeadProps, CartItemChangeProps, CartLineItem } from 'models/Cart';
import { Backdrop, CircularProgress, TableContainer } from '@mui/material';
import { BasicTable } from '../../shared/BasicTable/BasicTable';

import { CartTableRow } from './CartTableRow';

import Paper from '@mui/material/Paper';

import { CART_HEAD_CELLS } from '../../../utils/constans/tableHeads/cartTableHead';

const TABLE_HEAD_SETTINGS = {
    translateNs: 'cart',
    translatePrefix: 'CART.TABLE_HEAD',
    selectable: false,
    headContent: CART_HEAD_CELLS,
};

interface CartProductsTableProps {
    cartItems: CartLineItem[];
    handleChange: (props: CartItemChangeProps) => void;
    updatingCart: boolean;
}

export const CartProductsTable: React.FC<CartProductsTableProps> = ({
    cartItems,
    handleChange,
    updatingCart,
}) => (
    <>
        <TableContainer component={Paper}>
            <BasicTable<CartLineItem, CartHeadProps>
                fullList={cartItems}
                tableHeadSettings={TABLE_HEAD_SETTINGS}
                component={CartTableRow}
                handleChange={handleChange}
            />
        </TableContainer>
        <Backdrop
            open={updatingCart}
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </>
);
